const baseString = 'http://febfes.com/api/v1/';
export const serverString = `${baseString}`;
